import { render } from "./CardSistemaContabil.vue?vue&type=template&id=955b3020"
import script from "./CardSistemaContabil.vue?vue&type=script&lang=js"
export * from "./CardSistemaContabil.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__